// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.totalCell[data-v-a00c3f16] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
